import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { Container, Draggable } from "@smooth-dnd/react";
import { arrayMoveImmutable } from "array-move";
import { Box, Flex, Label, Switch, Text } from "@100mslive/roomkit-react";
import { DeleteIcon, Edit, MoveIcon } from "../../../../icons";
import ConfirmDialog from "../../../Common/ConfirmDialog";
import FullPageProgress from "../../../FullPageProgress";
import { ToastManager } from "../../../Toast/ToastManager";
import AccountModulesAddPopup from "./AccountModulesAddPopup";
import AccountModulesEditPopup from "./AccountModulesEditPopup";
import { SESSION_AUTH } from "../../../../common/auth";
import { ACCOUNT_SERVICES } from "../../../../services";
import "./style.scss";

const AccountModulesSetting = () => {
  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [userData, setUserData] = useState(null);
  const [isEditAccess, setIsEditAccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataFetched, setDataFetached] = useState(false);
  const [addNewModule, setAddNewModule] = useState(false);
  const [editModule, setEditModule] = useState(false);
  const [deleteModule, setDeleteModule] = useState(false);
  const [selectedModule, setSelectedModule] = useState("");
  const navigate = useNavigate();
  const [modules, setModules] = useState([]);
  useEffect(() => {
    if (isUserSession && isUserSession?.isVerify) {
      setUserData(isUserSession);
      if (isUserSession?.org?.isOwner || isUserSession?.org?.isAdmin) {
        setIsEditAccess(true);
      } else {
        setIsEditAccess(false);
        return navigate("/account/setting", { replace: true });
      }
    } else {
      return navigate("/");
    }
    return () => null;
  }, [isUserSession, navigate]);

  useEffect(() => {
    if (!userData || dataFetched) return;
    setDataFetached(true);
    try {
      setLoading(true);
      ACCOUNT_SERVICES.getModules({
        userId: userData.userId,
        org: userData?.org?.id,
      })
        .then(data => {
          if (data.code === 200) {
            setModules(data?.data?.list || []);
          } else if (data.code === 600) {
            LOGOUT_USER_SESSION();
          } else {
            ToastManager.addToast({ title: data.message });
          }
        })
        .catch(error => {
          ToastManager.addToast({ title: error.message });
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      ToastManager.addToast({ title: error.message });
    }
    return () => null;
  }, [userData, dataFetched, LOGOUT_USER_SESSION]);

  const onMoveModule = ({ removedIndex, addedIndex }) => {
    let uModules = arrayMoveImmutable(modules, removedIndex, addedIndex);
    setModules(uModules);
    onUpdate(uModules);
  };
  const onSwitchModule = (allow, index) => {
    let uModules = [...modules];
    uModules[index]["allow"] = allow;
    setModules(uModules);
    onUpdate(uModules);
  };

  const onUpdate = uModules => {
    if (!isEditAccess) return;
    if (uModules.length < 5) {
      ToastManager.addToast({ title: "Add at least 5 modules" });
    }
    ACCOUNT_SERVICES.modulesUpdate({
      userId: userData.userId,
      org: userData?.org?.id,
      modules: uModules,
    })
      .then(data => {
        if (data.code === 200) {
          // ToastManager.addToast({ title: data.message });
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(error => {
        ToastManager.addToast({ title: error.message });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onModuleDelete = () => {
    let parma = {
      userId: isUserSession.userId,
      org: isUserSession?.org?.id,
      slug: selectedModule?.slug,
      contentUrl: selectedModule?.contentUrl,
    };
    setLoading(true);
    setSelectedModule("");
    setDeleteModule(false);

    ACCOUNT_SERVICES.moduleDelete(parma)
      .then(data => {
        if (data.code === 200) {
          ToastManager.addToast({ title: data.message });
          setDataFetached(false);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({
          title: err?.message,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <React.Fragment>
      <div className="events-page-account-setting-content">
        <div className="events-page-account-setting-content-row">
          <Box className="events-page-account-setting-content-box">
            <div className="events-page-account-setting-content-box-title">
              Modules
            </div>
            {loading ? (
              <FullPageProgress
                fixed={modules?.length ? true : false}
                size={50}
              />
            ) : null}

            <div className="events-page-account-setting-modules-items">
              <Container
                dragHandleSelector=".events-page-account-setting-modules-items-row-dragHandle"
                lockAxis="y"
                onDrop={onMoveModule}
              >
                {modules.map((item, index) => (
                  <Draggable key={index}>
                    <div className="events-page-account-setting-modules-items-row">
                      <div className="events-page-account-setting-modules-items-row-content">
                        <Label
                          className="events-page-account-setting-modules-items-row-content-label"
                          css={{
                            cursor: "pointer",
                          }}
                        >
                          <Switch
                            checked={item?.allow}
                            onCheckedChange={() => {
                              if (isEditAccess) {
                                onSwitchModule(!item?.allow, index);
                              }
                            }}
                          />
                          {item?.name}
                        </Label>
                        {item?.custom ? (
                          <div className="events-page-account-setting-modules-items-row-content-type">
                            Custom Module
                          </div>
                        ) : null}
                      </div>
                      {isEditAccess ? (
                        <div className="events-page-account-setting-modules-items-row-action">
                          {item?.custom ? (
                            <>
                              <button
                                className="events-page-account-setting-modules-items-row-action-btn"
                                onClick={() => {
                                  setSelectedModule(item);
                                  setEditModule(true);
                                }}
                                type="button"
                                title="Edit Module"
                              >
                                <Edit />
                              </button>
                              <button
                                className="events-page-account-setting-modules-items-row-action-btn"
                                onClick={() => {
                                  setSelectedModule(item);
                                  setDeleteModule(true);
                                }}
                                type="button"
                                title="Delete Module"
                              >
                                <DeleteIcon />
                              </button>
                            </>
                          ) : null}
                          <button
                            className="events-page-account-setting-modules-items-row-action-btn events-page-account-setting-modules-items-row-dragHandle"
                            onClick={() => {}}
                            type="button"
                            title="Move Module"
                          >
                            <MoveIcon />
                          </button>
                        </div>
                      ) : null}
                    </div>
                  </Draggable>
                ))}
              </Container>
            </div>
            {isEditAccess && !loading && (
              <>
                <div className="events-page-account-setting-content-box-line"></div>

                <Flex
                  align="center"
                  className="events-page-account-setting-content-box-row"
                >
                  <Text
                    css={{
                      flex: "1 1 0",
                    }}
                    className="events-page-account-setting-content-box-text"
                  >
                    Add custom module
                  </Text>

                  <Button
                    color="primary"
                    variant="outlined"
                    className="events6ix-btn events6ix-btn-primary"
                    type="button"
                    onClick={() => {
                      setAddNewModule(true);
                    }}
                  >
                    Add Module
                  </Button>
                </Flex>
              </>
            )}
          </Box>
        </div>
      </div>
      {addNewModule && isEditAccess ? (
        <AccountModulesAddPopup
          onClose={() => {
            setAddNewModule(false);
          }}
          onUpdate={() => {
            setDataFetached(false);
            setAddNewModule(false);
          }}
        />
      ) : editModule && isEditAccess && selectedModule?.custom ? (
        <AccountModulesEditPopup
          module={selectedModule}
          onClose={() => {
            setEditModule(false);
            setSelectedModule("");
          }}
          onUpdate={() => {
            setDataFetached(false);
            setEditModule(false);
            setSelectedModule("");
          }}
        />
      ) : selectedModule?.custom && deleteModule ? (
        <ConfirmDialog
          open={selectedModule ? true : false}
          data={{
            title: selectedModule?.name,
            text: "Do you want to delete this module?",
            yesLabel: "Yes",
          }}
          onCancel={() => {
            setDeleteModule(false);
            setSelectedModule("");
          }}
          onAccept={onModuleDelete}
        />
      ) : null}
    </React.Fragment>
  );
};

export default AccountModulesSetting;
